import { useSelector } from "react-redux"
import styled from "styled-components"
import useWindowDimensions from "../../../hooks/useWindowSize"
import InputStopoverCheckbox from "../../shared/input/nakliyeHesaplama/InputStopoverCheckbox"
import { useDispatch } from "react-redux"
import { addNewRoutePoint, removeRouteItem, setIsDurationStrict, updateKmData, updateRoute, updateSelectedRouteItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import { IoIosWarning } from "react-icons/io";
import calculateTrafficScore from "../../../helper/nakliyeHesaplama/calculateTrafficScore"
import { useState } from "react"
import InputLocCityTown from "../../shared/input/nakliyeHesaplama/InputLocCityTown"
const Container = styled.div`
  width: ${({isRouteControlContainerOpen}) => isRouteControlContainerOpen ? "360px" : 0};
  height: 100%;
  overflow: auto;
  transition: .3s;
  color: ${({theme}) => theme.mainTextColor};
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${({theme}) => theme.mainTextColor};

  & *{
      display: ${({isRouteControlContainerOpen}) => !isRouteControlContainerOpen ? "none" : "block"};
      transition: .2s;
    }
    
    .title-container{
      width: 100%;
      padding: 20px;

      h3{
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);
      }
    }

    .route-container{
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px;

      .route-item{
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        .route-item-top{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .order{
            font-size: var(--font-size-sm);
            font-size: 12px;
            font-weight: var(--font-weight-lg);
          }

          .remove-btn{
            color: var(--color-main);
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            padding-right: 10px;

            &:hover{
              text-decoration: underline;
            }
          }
        }
      }
    }

    .add-destination-btn{
      color: var(--color-main);
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      margin: 20px;
      width: calc(100% - 40px);
      text-align: start;
      padding-left: 5px;
    }

    .route-response-container{
      margin: 20px 0;
      width: 100%;
      border-top: 1px solid ${({theme}) => theme.mainBorderColor};
      .route-response-list{
        display: flex;
        flex-direction: column;

        .route-response-item{
          display: flex;
          padding: 20px;
          padding-bottom: 30px;
          border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
          justify-content: space-between;
          align-items: flex-start;
          cursor: pointer;
          position: relative;

          &:hover{
            background-color: ${({theme}) => theme.secondaryBgColor};
          }

          .marker-sign{
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            background-color: var(--color-main);
            width: 5px;
            height: 100%;
          }

          .desc-side{
            width: max-content;
            max-width: 205px;
            
            .road-name{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
              color: ${({theme}) => theme.mainTextColor};
            }

            .label{
              font-size: 12px;
              font-weight: var(--font-weight-lg);
              padding-top: 5px;
            }

            .road-warnings{
              display: flex;
              flex-direction: column;
              gap: 5px;
              margin-top: 10px;

              .road-warning-item{
                display: flex;
                align-items: center;
                gap: 5px;
              }
              .warning-icon{
                font-size: 1.2rem;
                fill: var(--color-main);
              }

              .warning-item-text{
                font-size: 13px;
                font-weight: var(--font-weight-md);
              }
            }

          }

          .duration-side{
            width: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            gap: 10px;
            padding-left: 10px;

            .duration{
              color: var(--color-green);
              font-weight: var(--font-weight-lg);
              font-size: var(--font-size-sm);
              width: max-content;
            }

            .distance{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-md);
              color: ${({theme}) => theme.mainTextColor};
            }
          }
        }

      }

    }
`


const RouteControlContainer = () => {

  const {
    isRouteControlContainerOpen,
    route,
    routeResultList,
    selectedRouteItem
  } = useSelector(state => state.nakliyeHesaplama)

  const [hoveredRouteItemId, setHoveredRouteItemId] = useState(null)

  const dispatch = useDispatch()

  const {windowDimensions} = useWindowDimensions()

  const parseDuration = (str) => parseInt(str.replace('s', ''), 10); 

    const durations = routeResultList.map(item => parseDuration(item.duration));

    // Find min and max durations
    const minDuration = Math.min(...durations);
  
    // Helper to add label
    const getLabel = (duration) => {
      if (duration === minDuration) return 'En hızlı rota';
      return '';
    };
  
  const handleStopoverClick = (item) => {
    
    dispatch(updateRoute({
      ...item,
      isStopOver: !item.isStopOver
    }))
  }

    
  return (
    <Container isRouteControlContainerOpen={isRouteControlContainerOpen}>
      <div className="title-container">
        <h3>Rota Oluşturun</h3>
      </div>
      <div className="route-container">
        {
          route.map((item, i) => (
            <div className="route-item" onMouseEnter={() => setHoveredRouteItemId(item.id)} onMouseLeave={() => setHoveredRouteItemId(null)} key={i}>
              <div className="route-item-top">
                <div className="order">{i+1}. Rota Noktası {i === 0 && "(Başlangıç)"}{i === route.length-1 && "(Bitiş)"}</div>
                {
                  (item.id === hoveredRouteItemId && route.length > 2 && i !== 0) &&
                  <button className="remove-btn" onClick={() => dispatch(removeRouteItem(item))}>Kaldır</button>
                }
              </div>
              {/* <InputLoc isFirst={i === 0} data={item} labelText={"İl Seçin"} inputWidth={windowDimensions.width <= 1400 ? "100%" : "300px"} name={"routeItem"+i}/> */}
              <InputLocCityTown isFirst={i === 0} data={item} labelText={"İl Seçin"} inputWidth={windowDimensions.width <= 1400 ? "100%" : "300px"} name={"routeItem"+i}/>
              
              {
                (i !== 0 && i !== route.length-1) &&
                <InputStopoverCheckbox labelText={"Duraklama Noktası"} isChecked={item.isStopOver} handleClick={() => {handleStopoverClick(item); dispatch(setIsDurationStrict(false))}}/>
              }
            </div>
          ))
        }
      </div>
      {
        !route.find((item,i) => {
          return !item.lat || !item.lng
        }) &&
        <button className="add-destination-btn" onClick={() => dispatch(addNewRoutePoint())}>Hedef Ekle</button>
      }

      <div className="route-response-container">
        <div className="route-response-list">
          {
            routeResultList.map((item, i) =>  {
              const durationValue = parseDuration(item.duration);
              const label = getLabel(durationValue);
              
             return (
              <div className={"route-response-item"} key={i} onClick={() => {dispatch(updateKmData(item.localizedValues.distance.text)); dispatch(updateSelectedRouteItem(item)); dispatch(setIsDurationStrict(false))}}>
                {
                  item?.routeToken === selectedRouteItem?.routeToken &&
                  <div className="marker-sign"/>
                }
                <div className="desc-side">
                  <div className="road-name">{item.description} üzerinden</div>

                  {
                    label && <span className="label">{label}</span>
                  }

                  {
                    (calculateTrafficScore(item.travelAdvisory.speedReadingIntervals).totalScore >= 16600 && calculateTrafficScore(item.travelAdvisory.speedReadingIntervals).totalScore < 18600) && 
                    <span className="label">Hafif trafik var</span>
                  }

                  {
                    calculateTrafficScore(item.travelAdvisory.speedReadingIntervals).totalScore >= 18600 &&  
                    <span className="label">Yoğun trafik var</span>
                  }

                  <div className="road-warnings">
                  {(item?.warnings && item?.warnings?.length > 0) &&
                    item?.warnings.map((item, i) => (
                      <div className="road-warning-item" key={i}>
                        {item === "Bu rotada ücretli geçişler var." && <IoIosWarning className="warning-icon"/>}
                        <span className="warning-item-text" style={{fontWeight:  item === "Bu rotada ücretli geçişler var." && 600}}>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="duration-side">
                  <div className="duration">{item.localizedValues.duration.text.slice(0, -5)}k.</div>
                  <div className="distance">{item.localizedValues.distance.text}</div>
                </div>
              </div>
             )
          })
          }
        </div>
      </div>
    </Container>
  )
}

export default RouteControlContainer